/**
 * App Messages
 *
 * This contains all the text for the App component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app';

export default defineMessages({
  noAccessWorkspace: {
    id: `${scope}.noAccessWorkspace`,
    defaultMessage: 'You do not have access to any workspaces. Please contact your subscription administrator',
  },
  copyOf: {
    id: `${scope}.copyOf`,
    defaultMessage: 'Copy of ',
  },
  invalidLogin: {
    id: `${scope}.invalidLogin`,
    defaultMessage: 'Invalid credentials provided',
  },
  reviewerWarning : {
    id: `${scope}.reviewerWarning`,
    defaultMessage: 'As a Reviewer, you have the ability to add comments but other changes will not be saved.',
  },
});
